import { useState, useCallback } from 'react'
import { useRouter } from 'next/router'
import { Modal, Button } from 'antd'
import useTranslation from '@/hooks/useTranslation'

import SelectServices from '../../form/SelectServices'
import Close from '../../../svgs/CloseModal'

export default function NewRequest({ open, setOpen }) {
  const router = useRouter()
  const { t } = useTranslation()

  const [serviceId, setServiceId] = useState(null)
  const [isPrepaid, setIsPrepaid] = useState(false)

  const onServiceChange = useCallback((val, isPrepaid) => {
    setServiceId(val)
    setIsPrepaid(isPrepaid)
  }, [])

  return (
    <Modal
      className='!w-[30rem]'
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={false}
      centered
    >
      <div className='flex items-center justify-between mb-20'>
        <h3 className='text-gray text-xl font-semibold'>
          {t('addNewRequest')}
        </h3>
        <Close style='cursor-pointer w-20' onClick={() => setOpen(false)} />
      </div>
      <div className='table-filters'>
        <SelectServices
          onChange={onServiceChange}
          allExist={false}
          slug={true}
        />
      </div>
      <Button
        disabled={!serviceId}
        className='btn-green text-base font-semibold tracking-wide rounded-md py-16 w-full h-auto mt-16'
        onClick={() => {
          if (serviceId) {
            if (isPrepaid) {
              router.push(`/servizi/${serviceId}/pay`)
            } else {
              router.push(`/dashboard/servizi/${serviceId}/request`)
            }
            setOpen(false)
          }
        }}
      >
        {t('button.StartFillingForm')}
      </Button>
    </Modal>
  )
}
